import { useMemo } from "react";
import { Typography } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FintechProductOption } from "@hopper-b2b/types";
import { FintechPurchaseCard } from "@hopper-b2b/ui";
import type { DisruptionFintechProductProps } from "@tenant/disruption";
import clsx from "clsx";
import InfoOutlined from "../../../../assets/client/info-outlined.svg?react";
import styles from "./DisruptionFintechProductSelection.module.scss";

export const DisruptionFintechProductSelection = (props: {
  options: DisruptionFintechProductProps["selectionOffers"];
  onSelect: (index: number) => void;
  continueClicked: boolean;
}) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const showErrorState =
    props.continueClicked && !props.options.some((option) => option.selected);
  const { options } = props;

  const optionItems = useMemo(
    () =>
      options.map((option, index: number) => {
        const description = () => {
          switch (option.optionType) {
            case "declined":
              return option.description;
            case "attached":
              return `/ ${t("traveler")}`;
          }
        };

        return (
          <div
            className={clsx(
              styles.optionContainer,
              option.selected && styles.selected
            )}
            onClick={() => option.onClick()}
            key={index}
          >
            <div className={styles.optionTitle}>{option.title}</div>
            <div className={styles.optionCost}>
              {formatFiatCurrency(option.pricePerPaxLocalized, {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              })}
            </div>

            <div
              className={clsx(
                styles.optionDescription,
                styles[option.optionType]
              )}
            >
              {description()}
            </div>
          </div>
        );
      }),
    [formatFiatCurrency, options, t]
  );

  return (
    <div className={styles.DisruptionFintechProductSelection}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>{t("selectCoverageType")}</h3>
        {showErrorState ? (
          <div className={styles.requiredField}>
            <InfoOutlined className={styles.infoIcon} />
            {t("requiredField")}
          </div>
        ) : null}
      </div>
      {optionItems}
    </div>
  );
};
